import React from 'react'
import { Box, Text, Flex, PseudoBox, Divider, Tag } from '@chakra-ui/core'
import styled from '@emotion/styled'
import { NavLink, useLocation, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { BsTrophy } from 'react-icons/bs'
// import { isRtlSelector } from 'redux/selectors/general'
// import Joyride, { CallBackProps, STATUS, Step } from 'react-joyride'
// import { usePPTour } from 'components/ProductPerformance/tour/PPTourContext'
import { FEATURE_FLAGS } from 'constants/featureFlags'
import { featureFlagsBooleanMapSelector } from 'redux/selectors/featureFlags'
import { isAgentAllowedSelector } from 'redux/selectors/config'
// import { sidebarStep } from 'components/ProductPerformance/tour/productPerformanceTourSteps'
// import PPTourTooltip from 'components/ProductPerformance/tour/PPTourTooltip'
// import { JOYRIDE_STYLES } from 'components/ProductPerformance/tour/tourConstants'

import { ReactComponent as AiGrid } from 'assets/ai-grid.svg'

import LocaleText from 'components/LocaleText'
import useLocaleText from 'components/useLocaleText'
import keys from 'constants/keys'
import { RootState } from 'constants/interfaces'
import { ComposeButton } from 'components/Sidebar/ComposeButton'
import { GroupAvatars } from 'components/CommonComponents/GroupAvatars'
import { StoreeAvatar } from 'components/CommonComponents/StoreeAvatar'
import { CreateTaskV2Button } from 'components/Sidebar/CreateTaskV2Button'
import { CreateVMTaskButton } from 'components/Sidebar/CreateVMTaskButton'
import { CreateAITaskButton } from 'components/Sidebar/CreateAITaskButton'
import { ChooseContextButton } from './ChooseContextButton'
import { getOpenServiceCallDashboard, setDateFilter as setDateFilterServiceCall } from 'redux/actions/serviceCall'
import { CreateServiceCallButton } from './CreateServiceCallButton'
import { NotificationBellButton } from './NotificationBellButton'
import { StoreePlannerButton } from './StoreePlannerButton'
import { hasRscViewsSelector, serviceCallConfigSelector } from 'redux/selectors/config'
import { setIsPersonalView } from 'redux/actions/feed'
import {
  BookOpen,
  CalendarDays,
  ChartNoAxesCombined,
  ChartSpline,
  ClipboardList,
  FileInput,
  GalleryVertical,
  Headset,
  Library,
  MonitorCheck,
  Newspaper,
  Settings,
  ShoppingCart,
  Tags,
} from 'lucide-react'
import colors from 'constants/colors'

import { isSetupAllowedForUser } from 'utils/setupStorage'

const ICON_SIZE = 18 as const

const allowedUIDs = [
  '033750035',
  '302632377',
  '039267885',
  '200928497',
  '032817942',
  '204110902',
  '032472268',
  '040044406',
  '040490039',
  '305035560',
  '300095973',
  '037811171',
  '206016438',
  '306016478',
  '203893151',
  '039727433',
  '300170503',
  'sto-max',
  'sto-tra',
  '0523202400',
  '0523991103',
  '0526653810',
  '0523685333',
  '0504840002',
  '0523685372',
  '0522416770',
  '0542204190',
  '0545704250',
  '0526891122',
  '0544832276',
  '0502152299',
  '0526870641',
  '0508626916',
  '0526873555',
  '0524818514',
  '0523991072',
  '318084779',
]

interface IMenuItem {
  route: string
  title: string
  icon: React.ReactChild
  isHide: boolean
  id: string
  color?: string
  onClick?: () => void
  externalUrl?: string
  badge?: string
}

export const IconBlock = styled(Flex)`
  width: var(--sidebar-icon-size, 32px);
  height: var(--sidebar-icon-size, 32px);
  flex-shrink: 0;
  border-radius: 10px;
  justify-content: center;
  align-items: center;

  [data-compact-sidebar] & > svg {
    width: var(--sidebar-glyph-size, 20px);
    height: var(--sidebar-glyph-size, 20px);
  }
`
export const NavItem = styled(NavLink)`
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  font-size: var(--sidebar-font-size, 14px);
  padding: var(--sidebar-row-padding, 10px);
  border-radius: 10px;

  @media (max-width: 1000px) {
    padding: 5px;
  }

  &:hover,
  &:focus {
    text-decoration: none;
    color: inherit;
    background-color: #f1f1f1;
  }
`

const NavHeader = styled(Text)`
  margin: var(--sidebar-heading-margin, 10px 10px);
  color: #6b6b6b;
  font-size: var(--sidebar-font-size, 14px);
  font-weight: 500;
`

export const ActionButton = styled(PseudoBox)`
  display: flex;
  border-radius: 10px;
  padding: var(--sidebar-row-padding, 10px);
  align-items: center;
  column-gap: 10px;
  cursor: pointer;
  font-size: var(--sidebar-font-size, 14px);
  width: 100%;

  > p {
    font-size: inherit;
  }

  &:hover,
  &:focus {
    background-color: #f1f1f1;
  }
`
const NavMenu: React.FC<{ setIsHidden?: (value: boolean) => void }> = ({ setIsHidden }) => {
  const dispatch = useDispatch()
  const { isLoginByLink, uid } = useSelector((state: RootState) => state.auth)
  const { activeGroupID, retailConfig } = useSelector((state: RootState) => state.config)
  const { isLoading } = useSelector((state: RootState) => state.serviceCalls)
  const { permission, rid } = useSelector((state: RootState) => state.config.config)
  const isProdDemo = rid === 'prod_demo'
  const { isPersonalView } = useSelector((state: RootState) => state.feed)
  const theme = useSelector((state: RootState) => state.general.theme)
  const location = useLocation()
  const serviceCallsViews = useSelector(serviceCallConfigSelector)
  const { targetGroupId } = useParams()
  const currentRoute = location.pathname

  const t_comunications = useLocaleText('focus_btn_3')
  const t_inbox = useLocaleText('feed_header')
  const t_ai_feed = useLocaleText('ai_header')
  const t_my_schedules = useLocaleText('scheduls')
  const t_reports_sidebar = useLocaleText('reports_sidebar')
  const t_tasks_dashboard = useLocaleText('tasks_dashboard')
  const t_analytics_header = useLocaleText('analytics_header')
  const t_operations_header = useLocaleText('operations_header')
  const t_dashboards_header = useLocaleText('dashboards_header')
  const t_tasks = useLocaleText('sidebar_tasks_page')
  const t_digital_papers = useLocaleText('digital_papers')
  const t_service_calls_dashboard = useLocaleText('service_calls_dashboard')
  const t_analytics = useLocaleText('users_analytics')
  const t_actions = useLocaleText('admin_actions')
  const t_product_performance = useLocaleText('product_performance')
  const t_library = useLocaleText('library')

  const isAllowedToAccessSetup = isSetupAllowedForUser(uid!)
  const featureFlags = useSelector(featureFlagsBooleanMapSelector)
  const isAgentAllowed = useSelector(isAgentAllowedSelector)
  const hasRscViews = useSelector(hasRscViewsSelector)
  const t_my_tasks = useLocaleText('tasks')
  const t_my_rsc = useLocaleText('my_rsc')
  const t_my_service_calls = useLocaleText('service_call_section_titie')

  // ── PP feature tour: sidebar spotlight ──────────────────────────────────────
  // const { stage, completeTour } = usePPTour()
  // const isOnPPRoute = currentRoute.includes(keys.ROUTE_NAMES.PRODUCT_PERFORMANCE)
  // const isRtl = useSelector(isRtlSelector)
  // const sidebarStepRtl: Step[] = [{ ...sidebarStep[0], placement: isRtl ? 'left-start' : 'right-start' }]

  // const handleSidebarTourCallback = (data: CallBackProps) => {
  //   const { status } = data
  //   // SKIPPED = user dismissed the tour entirely
  //   if (status === STATUS.SKIPPED) completeTour()
  //   // FINISHED = user clicked through (or clicked the spotlighted nav button)
  //   // Stage will advance automatically via ProductPerformancePage's useEffect on navigation
  // }

  // Scroll the PP nav item into view before the sidebar tour starts so it's visible
  // even on small screens where the sidebar overflows and requires scrolling
  // useEffect(() => {
  //   if (stage === 'sidebar' && !isOnPPRoute) {
  //     const el = document.getElementById('nav_btn_product_performance')
  //     if (el) {
  //       el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  //     }
  //   }
  // }, [isOnPPRoute])

  const renderMenu = (menuList: IMenuItem[]) => {
    return menuList.map((item) => {
      if (item.isHide) {
        return null
      }

      if (item.externalUrl) {
        return (
          <NavItem
            to={keys.ROUTE_NAMES.EXTERNAL_APP}
            state={{ url: item.externalUrl, title: item.title }}
            key={item.id}
            id={item.id}
            style={() => ({ fontWeight: 'inherit' })}
          >
            <IconBlock background={item.color || 'transparent'}>{item.icon}</IconBlock>
            <Text mx="10px" textTransform="capitalize">
              <LocaleText text={item.title} />
            </Text>
          </NavItem>
        )
      }

      const isInboxItem = item.route === keys.ROUTE_NAMES.NEWS_FEED
      const isInboxActive = isInboxItem && currentRoute === keys.ROUTE_NAMES.NEWS_FEED
      const isPersonalActive = isInboxActive && isPersonalView === true && item.id === 'nav_btn_1'
      const isFeedActive = isInboxActive && isPersonalView === false && item.id === 'nav_btn_0'

      return (
        <NavItem
          onClick={item.onClick}
          to={
            item.route === keys.ROUTE_NAMES.REPORTS && activeGroupID
              ? `${keys.ROUTE_NAMES.REPORTS}/${activeGroupID}`
              : item.route
          }
          state={{ fromUserClick: true }}
          key={item.id}
          style={({ isActive }) => ({
            fontWeight: isInboxItem
              ? isPersonalActive || isFeedActive
                ? 'bold'
                : 'inherit'
              : isActive
              ? 'bold'
              : 'inherit',
          })}
          id={item.id}
        >
          <IconBlock background={item.color || 'transparent'}>{item.icon}</IconBlock>
          <Text mx="10px" textTransform="capitalize">
            <LocaleText text={item.title} />
          </Text>
          {item.badge && (
            <Tag
              bg={theme?.elementsColor}
              color="white"
              borderRadius="20px"
              px="10px"
              py="2px"
              fontSize="10px"
              minH="unset"
              mx="10px"
            >
              <LocaleText text={item.badge} />
            </Tag>
          )}
        </NavItem>
      )
    })
  }

  const inboxMenu: IMenuItem[] = [
    {
      route: keys.ROUTE_NAMES.NEWS_FEED,
      isHide: false,
      title: t_inbox,
      icon: <Newspaper color="#3ED598" size={20} />,
      color: '#E6F9F1',
      id: 'nav_btn_0',
      onClick: () => {
        dispatch(setIsPersonalView(false))
      },
    },
    {
      route: keys.ROUTE_NAMES.NEWS_FEED,
      isHide: false,
      title: t_ai_feed,
      icon: (
        <AiGrid
          color="#5DA9E9"
          style={{ width: 'var(--sidebar-glyph-size, 20px)', height: 'var(--sidebar-glyph-size, 20px)' }}
        />
      ),
      color: '#E8F4FC',
      id: 'nav_btn_1',
      onClick: () => {
        dispatch(setIsPersonalView(true))
      },
    },
  ]

  const analyticsMenu: IMenuItem[] = [
    {
      route: keys.ROUTE_NAMES.REPORTS,
      isHide: !!isLoginByLink,
      title: t_reports_sidebar,
      icon: <ChartNoAxesCombined size={ICON_SIZE} color="#FF6868" strokeWidth={2} />,
      color: '#ffdbff',
      id: 'nav_btn_4',
      ...(isProdDemo ? { externalUrl: 'https://nike-flow-dash.base44.app/' } : {}),
    },
    {
      route: keys.ROUTE_NAMES.RANKINGS_LIST,
      isHide: false,
      title: useLocaleText('kpis'),
      icon: <BsTrophy size={ICON_SIZE} color="#845EF7" />,
      color: '#EDE9FE',
      id: 'nav_btn_8',
      ...(isProdDemo ? { externalUrl: 'https://cunning-track-your-pace.base44.app' } : {}),
    },
    {
      route: keys.ROUTE_NAMES.ANALYTICS,
      isHide: permission?.users !== 3,
      title: t_analytics,
      icon: <ChartSpline size={ICON_SIZE} color="green" />,
      color: '#b0fff2',
      id: 'nav_btn_6',
    },
    {
      route: keys.ROUTE_NAMES.PRODUCT_PERFORMANCE,
      isHide: !featureFlags[FEATURE_FLAGS.PRODUCT_PERFORMANCE],
      title: t_product_performance,
      icon: <Tags size={ICON_SIZE} color="#7C3AED" strokeWidth={2.5} />,
      color: '#EDE9FE',
      id: 'nav_btn_product_performance',
      ...(isProdDemo ? { externalUrl: 'https://productsinsightsdemo.mystore-e.com/?brand=Nike' } : {}),
    },
  ]

  const operationsMenu: IMenuItem[] = [
    {
      route: hasRscViews ? keys.ROUTE_NAMES.TASKS : keys.ROUTE_NAMES.HUB,
      title: hasRscViews ? t_my_tasks : t_tasks,
      icon: <ClipboardList size={ICON_SIZE} color="#d97706" />,
      color: '#fff3c5',
      id: 'nav_btn_7',
      isHide: false,
    },
    {
      route: keys.ROUTE_NAMES.RSC,
      title: t_my_rsc,
      icon: <BookOpen size={ICON_SIZE} color="#2563eb" />,
      color: '#dbeafe',
      id: 'nav_btn_rsc',
      isHide: !hasRscViews,
    },
    {
      route: keys.ROUTE_NAMES.SVC,
      title: t_my_service_calls,
      icon: <Headset size={ICON_SIZE} color="#d97706" />,
      color: '#FEF3E6',
      id: 'nav_btn_svc',
      isHide: serviceCallsViews.length === 0,
    },
    {
      route: keys.ROUTE_NAMES.SALES_OPPORTUNITIES,
      title: useLocaleText('sales_opportunities', true),
      icon: <ShoppingCart size={ICON_SIZE} color="white" strokeWidth={2.5} />,
      color: '#e34e4e',
      id: 'nav_btn_10',
      isHide: !isAllowedToAccessSetup,
    },
    {
      route: keys.ROUTE_NAMES.ORGANIZATION_TREE,
      title: useLocaleText('organization_tree', true),
      icon: <GalleryVertical size={ICON_SIZE} color="white" strokeWidth={2.5} />,
      color: '#9fc965',
      id: 'nav_btn_11',
      isHide: !isAllowedToAccessSetup,
    },
    {
      route: keys.ROUTE_NAMES.LIBRARY,
      title: t_library,
      icon: <Library size={20} color="#0891b2" />,
      color: '#cffafe',
      id: 'nav_btn_library',
      // Always shown, regardless of the drive permission — the page itself gates data/actions and shows a
      // "no permission" state instead of fetching, rather than hiding the nav entry entirely.
      isHide: false,
    },
    {
      route: keys.ROUTE_NAMES.MY_SCHEDULES,
      isHide: false,
      title: t_my_schedules,
      icon: <CalendarDays size={20} color="#7C3AED" />,
      color: '#EDE9FE',
      id: 'nav_btn_my_schedules',
      onClick: () => {},
    },
  ]

  const dashboardsMenu: IMenuItem[] = [
    {
      route: keys.ROUTE_NAMES.NEW_TASK_DASHBOARD,
      isHide: false,
      title: t_tasks_dashboard,
      icon: <MonitorCheck size={ICON_SIZE} color="#FF6B6B" />,
      color: '#FEE8E8',
      id: 'nav_btn_3',
      // onClick: () => {
      //   if (!isInsightsLoading || !isFetchingData) {
      //     dispatch(setDateFilter(null))
      //     dispatch(getInsightsV2({}))
      //     dispatch(getInitialData(groups, activeGroupID, undefined, undefined, true))
      //     dispatch(setFilter({ all: true, groups: [], tags: [], users: [], createdByMe: false }))
      //     dispatch(setChoosenTaskViewIds([]))
      //   }
      // },
    },
    {
      route: keys.ROUTE_NAMES.SERVICE_CALLS_DASHBOARD,
      isHide: serviceCallsViews.length === 0,
      title: t_service_calls_dashboard,
      icon: <Headset size={ICON_SIZE} color="#FFA94D" />,
      color: '#FEF3E6',
      id: 'nav_btn_5',
      onClick: () => {
        if (!isLoading) {
          setDateFilterServiceCall(null)
          dispatch(getOpenServiceCallDashboard(activeGroupID!))
        }
      },
    },
  ]

  const otherItems: IMenuItem[] = [
    {
      route: keys.ROUTE_NAMES.EXTERNAL_SITE,
      title: t_digital_papers,
      id: 'nav_btn_6',
      isHide: false,
      icon: <FileInput size={ICON_SIZE} color="#94D82D" />,
      color: '#F0F9E6',
    },
  ]

  const aiMenu: IMenuItem[] = [
    {
      route: keys.ROUTE_NAMES.AGENT,
      title: 'Agent',
      icon: <StoreeAvatar size="var(--sidebar-icon-size, 32px)" />,
      id: 'nav_btn_agent',
      isHide: !isAgentAllowed,
      badge: 'New - Beta',
    },
  ]

  return (
    <Box
      as="nav"
      mt={{
        base: '0',
      }}
    >
      {/* Sidebar step: spotlight the PP nav button when user hasn't visited the feature yet */}
      {/* <Joyride
        steps={sidebarStepRtl}
        run={stage === 'sidebar' && !isOnPPRoute}
        continuous={false}
        showSkipButton
        disableOverlayClose
        disableScrolling
        scrollToFirstStep={false}
        spotlightPadding={0}
        tooltipComponent={PPTourTooltip}
        callback={handleSidebarTourCallback}
        styles={JOYRIDE_STYLES}
      /> */}
      {currentRoute.includes(keys.ROUTE_NAMES.REPORTS) && retailConfig?.is_personalization_mode && targetGroupId && (
        <GroupAvatars group={targetGroupId} />
      )}
      <NotificationBellButton setIsHidden={setIsHidden} />

      {isAgentAllowed && (
        <>
          <NavHeader style={{ marginTop: '16px' }}>AI</NavHeader>
          {renderMenu(aiMenu)}
          <Divider mb="10px" />
        </>
      )}

      <Flex flexDir="column" style={{ marginBottom: '10px' }}>
        <NavHeader>{t_actions}</NavHeader>
        <ComposeButton setIsHidden={setIsHidden} />
        <CreateTaskV2Button setIsHidden={setIsHidden} />
        <CreateVMTaskButton setIsHidden={setIsHidden} />
        {featureFlags[FEATURE_FLAGS.AI_VM] && <CreateAITaskButton setIsHidden={setIsHidden} />}
        {isProdDemo && <StoreePlannerButton />}
        <CreateServiceCallButton setIsHidden={setIsHidden} />
      </Flex>

      <NavHeader>{t_comunications}</NavHeader>
      {renderMenu(inboxMenu)}
      <Divider mb="10px" />
      <Box py="10px">
        <ChooseContextButton setIsHidden={setIsHidden} />
      </Box>
      <NavHeader>{t_analytics_header}</NavHeader>
      {renderMenu(analyticsMenu)}

      <NavHeader>{t_operations_header}</NavHeader>
      {renderMenu(operationsMenu)}
      <NavHeader>{t_dashboards_header}</NavHeader>
      {renderMenu(dashboardsMenu)}
      {allowedUIDs.includes(uid!) && renderMenu(otherItems)}
      {permission?.users === 3 && (
        <>
          <NavHeader>Administration</NavHeader>
          <NavItem
            to={keys.ROUTE_NAMES.ADMIN_CONSOLE}
            state={{ fromUserClick: true }}
            style={({ isActive }) => ({ fontWeight: isActive ? 'bold' : 'inherit' })}
            id="nav_btn_admin"
          >
            <IconBlock background="#FEE2E2">
              <Settings size={ICON_SIZE} color={colors.red} />
            </IconBlock>
            <Text mx="10px" textTransform="capitalize">
              <LocaleText text="admin_console" />
            </Text>
          </NavItem>
        </>
      )}
    </Box>
  )
}

export default NavMenu
